/* React */
import React from "react";

/* Stylesheet */
import styles from "./QRCodeContainer.module.scss";

/* Interfaces */
interface QRCodeProps {
  code?: string;
  otpUrl?: string;
}

const QRCode: React.FC<QRCodeProps> = ({
  code,
  otpUrl,
}) => {
  return (
    <div
      data-cy="qr-code-container"
      className={styles.qr_code_container}
    >
      <div
        data-cy="otp-url"
        data-url={otpUrl}
        className={styles.info_message}
      >
        <h1>Two-Factor Authentication</h1>
        <p>
          Scan the QR-Code with your{" "}
          <span>authenticator app</span> and enter the code
          to enable two-factor authentication.
        </p>
      </div>
      <img
        data-cy="qr-code"
        className={styles.qr_code}
        src={code}
        alt="QR Code"
      />
    </div>
  );
};

export default QRCode;
